import type {EditableFieldType} from 'typings/portaro.be.types';
import type {IHttpService} from 'angular';
import {responseToData, unRestangularize} from 'shared/utils/data-service-utils';

export default class EditableFieldTypeDataService {
    public static readonly serviceName = 'editableFieldTypeDataService';
    private static readonly ROUTE = 'editable-field-types';

    /*@ngInject*/
    constructor(private $http: IHttpService,
                private Restangular: Restangular.IService) {
    }

    @unRestangularize()
    public async queryByRecordEditation(recordEditationId: string): Promise<EditableFieldType[]> {
        try {
            return await this.Restangular
                .all(EditableFieldTypeDataService.ROUTE)
                .getList({recordEditation: recordEditationId});
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

}
